<div class="container-fluid">
    <div class="row">
      <table id="tblInstructions" class="nj-table nj-table--hover nj-table--striped nj-cursor">
        <thead>
          <tr [style]="'background-color: #d8d8d8'" class="pointer">
            <th (click)="DataGridHelper.SortData('notifiedOn')">Notified On (UTC)</th>
            <th (click)="DataGridHelper.SortData('startDate')">Start Date (UTC)</th>
            <th (click)="DataGridHelper.SortData('endDate')">End Date (UTC)</th>
            <th (click)="DataGridHelper.SortData('instructionType')">Instruction Type</th>
            <th (click)="DataGridHelper.SortData('status')">Status</th>
            <th>Actions</th>  
          </tr>
        </thead>
        <tbody>
          @for(instruction of DataGridHelper.CurrentPageData; track instruction.instructionId; let i = $index) {
          <tr>
            <td>{{DateFormatHelper.GetDisplayDate(instruction.notifiedOn)}}</td>
            <td>{{DateFormatHelper.GetDisplayDateOnly(instruction.startDate)}} 00:00</td>
            <td>{{(instruction.endDate? DateFormatHelper.GetDisplayDateOnly(instruction.endDate) + " 00:00" : "")}}</td>
            <td>{{ instruction.instructionType }}</td>
            <td>{{ instruction.status }}</td>
            <td>
              <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
              (buttonClick)="ViewInstruction(instruction.instructionId)">
              View
              </nj-button>
              &nbsp;
              <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
              (buttonClick)="CopyToNew(instruction.instructionId)">
              Copy
              </nj-button>
            </td>
          </tr>
        }
        </tbody>
      </table>
      <nj-pagination
        [count]="DataGridHelper.PageCount" 
        [shouldMinify]="true" (selectedItem)="DataGridHelper.ChangePage($event)"></nj-pagination>
   
    </div>
  </div>